module.exports = {
  "chat.end":"重新開始您的聊天對話",
  "chat.cancel":"取消",
  "chat.endall":"結束聊天",
  "chat.cookie":"此數字助理使用 cookie 來確保您獲得最佳體驗",
  "chat.learn":"了解更多",
  "chat.minimize":"最小化",
  "chat.hide":"關",
  "chat.hidebot.text":"關閉將使頭像消失 15 分鐘",
  "chat.hidebot":"關閉機器人",
  "chat.restart":"重新開始",
  "switch.language":"切換語言",
  "switch.property":"開關屬性",
  "restart.converstation":"重啟轉換",
  "chat.endtext":"您確定要結束當前聊天嗎？",
  "check.availabity":"檢查可用性",
  "check.availabity.submit":"提交",
  "check.availabity.cancel":"取消",
  "check.availabity.adults":"成年人 ",
  "check.availabity.children":"孩子們",
  "check.availabity.child.age":"年齡 - 兒童",
  "feedback.leave":"留下反馈信息",
  "feedback.leave.message":"請留言",
};
